import type { TimeframeSelection } from '../../../types/timeframe';
import { computeDateRange } from './computeDateRange';

/**
 * Default filter: Monthly + Past 12 Months
 */
export function getDefaultTimeframe(): TimeframeSelection {
  const { startDate, endDate } = computeDateRange('past12Months');
  return {
    granularity: 'monthly',
    preset: 'past12Months',
    startDate,
    endDate,
  };
}
